import { translate } from 'preact-i18n';

/**
 * Event types and their corresponding emojis/icons
 * Used to display event indicators on calendar days
 */
export const EVENT_ICONS = Object.freeze({
  world_cup_2026: '⚽',
  // Add more event types here as needed
  // independence_day: '🎆',
  // christmas: '🎄',
});

/**
 * Event types and their corresponding translation configuration
 * Used for accessibility and display text
 * Format: { namespace: 'badges', key: 'mundial_2026' }
 * Uses the same pattern as encodePassengers.js
 */
export const EVENT_LABELS = Object.freeze({
  // Add more event types here as needed
  // independence_day: { namespace: 'badges', key: 'independence_day' },
  // christmas: { namespace: 'badges', key: 'christmas' },
});

/**
 * Get emoji/icon for a specific event type
 * @param {string} eventType - Event type (e.g., 'world_cup_2026')
 * @returns {string} Emoji string or empty string if type not found
 */
export const getEventEmoji = (eventType) => {
  return EVENT_ICONS[eventType] || '';
};

/**
 * Get translated label for a specific event type
 * Uses translate function from preact-i18n (same pattern as encodePassengers.js)
 * @param {string} eventType - Event type (e.g., 'world_cup_2026')
 * @param {Object} dictionary - Translation dictionary (from preact-i18n)
 * @returns {string} Translated label string or empty string if type not found
 */
export const getEventLabel = (eventType, dictionary = null) => {
  const labelConfig = EVENT_LABELS[eventType];
  if (!labelConfig) return '';
  
  // If no dictionary provided, return empty string (fallback)
  if (!dictionary) return '';
  
  // Use translate function directly (same pattern as encodePassengers.js)
  return translate(labelConfig.key, labelConfig.namespace, dictionary) || '';
};

